import { render } from "./CharTabGötterlicht.vue?vue&type=template&id=9dd812aa"
import script from "./CharTabGötterlicht.vue?vue&type=script&lang=js"
export * from "./CharTabGötterlicht.vue?vue&type=script&lang=js"

import "./CharTabGötterlicht.vue?vue&type=style&index=0&id=9dd812aa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__